import { render, staticRenderFns } from "./InfoWorkAnalysis.vue?vue&type=template&id=37773b61&scoped=true&"
import script from "./InfoWorkAnalysis.vue?vue&type=script&lang=js&"
export * from "./InfoWorkAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37773b61",
  null
  
)

export default component.exports